import { db } from 'boot/firebase';
import { collectionGroup, deleteDoc, doc, getDocs, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { map } from 'lodash';

import GenericDB from './generic-db';

export default class UserInvitationsDB extends GenericDB {
  constructor() {
    super('userInvitations');
  }

  /**
   * Add clients to an existing invitation
   * @param {string} email
   * @param {Array<string>} clientIds
   */
  addClients(email, clientIds) {
    const collectionRef = this.getSubcollectionRef(email, 'invitationClients');
    const createActions = map(clientIds, (client) => {
      const docRef = doc(collectionRef, client);
      return setDoc(
        docRef,
        {
          client,
          createTimestamp: serverTimestamp(),
        },
        { merge: true },
      );
    });
    return Promise.all(createActions);
  } // addClients()

  /**
   * Delete clients from an existing invitation
   * @param {string} email
   * @param {Array<string>} clientIds
   */
  deleteClients(email, clientIds) {
    const collectionRef = this.getSubcollectionRef(email, 'invitationClients');
    const deleteActions = map(
      clientIds,
      (client) => deleteDoc(doc(collectionRef, client)),
    );
    return Promise.all(deleteActions);
  } // deleteClients()

  async readClients(email) {
    // @todo: add error handler for the request
    const collectionRef = this.getSubcollectionRef(email, 'invitationClients');
    const result = await getDocs(collectionRef);

    return result.docs.map((ref) => (
      {
        id: ref.id,
        ...ref.data(),
      }));
  } // readClients()

  /**
   * Read all invitations associated with a client. Returns a consolidated result with
   * both userInvitations document and client sub-document
   * @param clientId
   */
  // eslint-disable-next-line class-methods-use-this
  async readByClient(clientId) {
    let queryBuilder = collectionGroup(db, 'invitationClients');
    queryBuilder = query(queryBuilder, where('client', '==', clientId));

    const querySnapshot = await getDocs(queryBuilder);

    const clientInvitationActions = map(querySnapshot.docs, async (docSnap) => {
      const invitationEmail = docSnap.ref.parent.parent.id;
      const invitation = await this.read(invitationEmail);

      return {
        id: docSnap.id,
        ...docSnap.data(),
        ...invitation,
      };
    });

    return Promise.all(clientInvitationActions);
  } // readByClient()
}
